import React from 'react';

import cn from 'clsx';

import { IEventsHost } from '@r-client/data/graphql-types';
import { Avatar } from '@r-client/shared/ui/core';

import styles from './host-list.module.scss';

interface IHostListProps {
  forceExpand?: boolean;
  hosts: IEventsHost[];
  dataTestId?: string;
}

const DEFAULT_MAX_VISIBLE_HOSTS = 6;

export const HostList: React.FC<React.PropsWithChildren<IHostListProps>> = ({
  forceExpand = false,
  hosts,
  dataTestId,
}) => {
  const canBeCollapsed = hosts.length > DEFAULT_MAX_VISIBLE_HOSTS;
  const isCollapsed = canBeCollapsed && !forceExpand;

  return (
    <div className={cn(styles.hostList)} data-testid={dataTestId}>
      {hosts.map((host, index) => {
        const hideAvatar = isCollapsed && index + 1 > DEFAULT_MAX_VISIBLE_HOSTS;
        const showPlacehoder =
          isCollapsed && index + 1 === DEFAULT_MAX_VISIBLE_HOSTS;
        return (
          <React.Fragment key={host.id}>
            <Avatar
              url={host.avatarUrl || undefined}
              size="xSmall"
              className={cn(styles.avatar, {
                [styles.avatarHidden]: hideAvatar,
              })}
            />

            {showPlacehoder && (
              <div className={styles.placehoder}>{hosts.length}</div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
